import React, {createContext, useContext} from 'react';

const ActivesContext = createContext();

export const ActivesProvider = ({ children, value }) => {
    return (
        <ActivesContext.Provider value={value}>
            {children}
        </ActivesContext.Provider>
    );
};

export const useActives = () => {
    const context = useContext(ActivesContext);
    if (!context) {
        throw new Error('useActives must be used within ActivesProvider');
    }
    return context;
};